import { useNavigate } from 'react-router-dom'
import { Controller, useForm } from 'react-hook-form'

// Components
import { Rectangle } from '../../components/Rectangle/Rectangle'
import { Input } from '../../components/Input/Input'
import { Button } from '../../components/Button/Button'
import { AnimatedScreenWrapper } from '../../components/AnimatedScreenWrapper/AnimatedScreenWrapper'

// Svg
import { Logo } from '../../assets'

// Styles
import './email.scss'

// Utils
import { validateEmail } from '../../utils/validateEmail'

export interface EmailScreenProps {}

export const EmailScreen = (props: EmailScreenProps) => {
  const {} = props
  let navigate = useNavigate()

  const { handleSubmit, control } = useForm()

  const onSubmit = handleSubmit((data) => {
    navigate('/first-name', { state: data })
  })

  return (
    <div className="full-screen email-bg">
      <AnimatedScreenWrapper>
        <div className="grid">
          <div>
            <Logo />
          </div>
          <form onSubmit={onSubmit}>
            <Rectangle>
              <h5 className="secondary-title">Enter your email and password</h5>

              <Controller
                control={control}
                rules={{
                  required: true,
                  validate: (value) => {
                    if (!validateEmail(value)) return 'Please enter valid email'
                  },
                }}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                  <Input
                    type="text"
                    placeholder="Your email"
                    onChange={onChange}
                    value={value || ''}
                    errorMessage={error ? (error?.message ? error.message : 'Required field') : null}
                  />
                )}
                name="email"
              />

              <Controller
                control={control}
                rules={{
                  required: true,
                  maxLength: 50,
                  minLength: 6,
                }}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                  <Input
                    type="text"
                    placeholder="Password"
                    onChange={onChange}
                    value={value || ''}
                    errorMessage={error ? 'Length must be between 6 and 50' : null}
                  />
                )}
                name="password"
              />

              <Button type="submit">next</Button>
            </Rectangle>
          </form>
        </div>
      </AnimatedScreenWrapper>
    </div>
  )
}
